import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

export const appointmentRequestEntityAdapter: EntityAdapter = {
  entity: "appointmentRequest",
  searchIdParameter: "company_subject_set__id__in",
  searchAutoFocus: false,
  afterColumnFilter: (filter, params) => {
    if (filter.column === "status" && filter.value === "completed") {
      params["include_completed"] = true;
    }
  },
};
